module.exports = __webpack_public_path__ + "static/one-app-to-track-time-crew-fd3e40de47f6cd0989b40e4a7e08764e.png";